const UNREZIZABLE_MIME_TYPES = ['image/gif', 'image/svg+xml', 'image/avif'];

export default UNREZIZABLE_MIME_TYPES;
